export default function IconViewOff({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M30.6936 15.9999C30.6936 15.9999 24.1156 7.69434 15.9991 7.69434C7.88269 7.69434 1.30469 15.9999 1.30469 15.9999C1.30469 15.9999 7.88269 24.3054 15.9991 24.3054C24.1156 24.3054 30.6936 15.9999 30.6936 15.9999Z"
        fill="#E4F1F5"
      />
      <path
        d="M15.9991 7.69434C7.88269 7.69434 1.30469 15.9999 1.30469 15.9999C1.30469 15.9999 1.82347 16.6541 2.74858 17.5958C5.11885 15.1859 10.161 10.8888 15.9991 10.8888C21.8373 10.8888 26.8794 15.1859 29.2497 17.5984C30.1748 16.6567 30.6936 15.9999 30.6936 15.9999C30.6936 15.9999 24.1156 7.69434 15.9991 7.69434Z"
        fill="white"
      />
      <path
        d="M15.9998 21.1256C18.8225 21.1256 21.1109 18.8372 21.1109 16.0144C21.1109 13.1916 18.8225 10.9033 15.9998 10.9033C13.177 10.9033 10.8887 13.1916 10.8887 16.0144C10.8887 18.8372 13.177 21.1256 15.9998 21.1256Z"
        fill="#66E1FF"
      />
      <path
        d="M12.3868 19.6272C11.4459 18.6652 10.9224 17.3709 10.9298 16.0253C10.9372 14.6798 11.4749 13.3913 12.4264 12.4397C13.3778 11.4881 14.6661 10.9501 16.0118 10.9425C17.3574 10.9348 18.6517 11.4581 19.614 12.3989L12.3868 19.6272Z"
        fill="#C2F3FF"
      />
      <path
        d="M25.6057 11.2598C27.4905 12.6243 29.1994 14.2166 30.6938 16.0003C30.6938 16.0003 24.1158 24.3059 15.9993 24.3059C14.6993 24.2984 13.4076 24.0985 12.166 23.713"
        stroke="#191919"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.37491 20.7277C4.49707 19.3659 2.79417 17.778 1.30469 15.9999C1.30469 15.9999 7.88269 7.69434 15.9991 7.69434C17.0771 7.69934 18.1501 7.83884 19.1936 8.10961"
        stroke="#191919"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.8887 15.9998C10.8887 14.6442 11.4272 13.3442 12.3857 12.3857C13.3442 11.4272 14.6442 10.8887 15.9998 10.8887"
        stroke="#191919"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.1111 16C21.1111 17.3556 20.5727 18.6556 19.6141 19.6141C18.6556 20.5727 17.3556 21.1111 16 21.1111"
        stroke="#191919"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M28.4577 3.54199L3.54102 28.4587"
        stroke="#191919"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
